import { Component, input, output } from '@angular/core';

import { BadgeComponent } from '@camelot/ui';
import { CamBaseComponent } from '@camelot/utils';

import { ActiveFilterTag } from '../types';

@Component({
  selector: 'cam-filters-tag',
  templateUrl: './filters-tag.component.html',
  styleUrls: ['./filters-tag.component.scss'],
  imports: [BadgeComponent],
})
export class FiltersTagComponent extends CamBaseComponent {
  activeFilter = input<ActiveFilterTag[]>([]);

  removedFilter = output<ActiveFilterTag>();

  public remove(filter: ActiveFilterTag) {
    this.removedFilter.emit(filter);
  }
}
